var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0C14.6047 0 0.5 14.1047 0.5 31.5C0.5 48.8953 14.6047 63 32 63C49.3953 63 63.5 48.8953 63.5 31.5C63.5 14.1047 49.3953 0 32 0ZM45.6055 21.2133L30.7977 41.7445C30.5907 42.0334 30.3179 42.2688 30.0018 42.4312C29.6857 42.5935 29.3354 42.6782 28.9801 42.6782C28.6247 42.6782 28.2745 42.5935 27.9584 42.4312C27.6423 42.2688 27.3695 42.0334 27.1625 41.7445L18.3945 29.5945C18.1273 29.2219 18.3945 28.7016 18.8516 28.7016H22.1492C22.8664 28.7016 23.5484 29.0461 23.9703 29.6367L28.9766 36.5836L40.0297 21.2555C40.4516 20.6719 41.1266 20.3203 41.8508 20.3203H45.1484C45.6055 20.3203 45.8727 20.8406 45.6055 21.2133Z",
    fill: "#52C41A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/successCheck.dd5ce5d3.svg";
export { ForwardRef as ReactComponent };